module.exports = __webpack_public_path__ + "img/volume_down.c8030600.svg";